<template>
  <el-dialog
    :title="$t('PointsMall.InputInformation')"
    :visible.sync="dialogVisible"
    :before-close="handleClose"
    :close-on-click-modal="false"
    :width="goodsType == 0 ? '700px' : '500px'"
  >
    <div>
      <!-- :rules="rules" -->
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        :loading="loading"
        label-width="160px"
        class="demo-ruleForm exchange-form-dialog"
      >
        <el-form-item
          :label="$t('PointsMall.ContactPerson')"
          prop="ContactsName"
          :rules="[
            {
              required: true,
              message: $t('InvoiceInquiry.PleaseEnter'),
              trigger: 'change'
            }
          ]"
        >
          <el-input
            v-model="ruleForm.ContactsName"
            :placeholder="$t('InvoiceInquiry.PleaseEnter')"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('PointsMall.TelephoneNumber')"
          prop="ContactsPhone"
          :rules="[
            {
              required: true,
              message: $t('InvoiceInquiry.PleaseEnter'),
              trigger: 'change'
            },
            { required: true, validator: handleUsername, trigger: ['blur'] }
          ]"
        >
          <el-input
            v-model="ruleForm.ContactsPhone"
            :placeholder="$t('InvoiceInquiry.PleaseEnter')"
          ></el-input>
        </el-form-item>
        <template v-if="goodsType == 0">
          <!-- :max="selectedItem.DetailInventory" -->
          <!-- 兑换数量在外面输入，如果后期要在谈框里输入时再放开 -->
          <!-- <el-form-item
            label="兑换数量"
            prop="Num"
            :rules="[
              { required: true, message: '请填写兑换数量', trigger: 'change' }
            ]"
          >
            <el-input
              type="number"
              v-model="ruleForm.Num"
              placeholder="请填写兑换数量"
            ></el-input>
          </el-form-item> -->
          <el-form-item
            :label="$t('PointsMall.DeliveryAddress')"
            class="address-select"
          >
            <el-form-item
              :label="''"
              prop="ShippingProvinceID"
              :rules="[
                {
                  required: true,
                  message: $t('InvoiceInquiry.PleaseSelect'),
                  trigger: 'change'
                }
              ]"
            >
              <el-select
                v-model="ruleForm.ShippingProvinceID"
                :placeholder="$t('InvoiceInquiry.PleaseSelect')"
                clearable
                filterable
                remote
                :remote-method="searchProvince"
                @change="provinceChange"
              >
                <el-option
                  v-for="item in provincesList"
                  :label="item.ItemName"
                  :key="item.ItemValue"
                  :value="item.ItemValue"
                >
                  {{ item.ItemName }}
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              :label="''"
              prop="ShippingCityID"
              :rules="[
                {
                  required: true,
                  message: $t('InvoiceInquiry.PleaseSelect'),
                  trigger: 'change'
                }
              ]"
            >
              <el-select
                v-model="ruleForm.ShippingCityID"
                :placeholder="$t('InvoiceInquiry.PleaseSelect')"
                clearable
                filterable
                remote
                :remote-method="searchCity"
                @change="cityChange"
              >
                <el-option
                  v-for="item in cityList"
                  :label="item.ItemName"
                  :key="item.ItemValue"
                  :value="item.ItemValue"
                >
                  {{ item.ItemName }}
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              :label="''"
              prop="ShippingDistrictID"
              :rules="[
                {
                  required: true,
                  message: $t('InvoiceInquiry.PleaseSelect'),
                  trigger: 'change'
                }
              ]"
            >
              <el-select
                v-model="ruleForm.ShippingDistrictID"
                :placeholder="$t('InvoiceInquiry.PleaseSelect')"
                clearable
                filterable
                remote
                :remote-method="searchDistrict"
                @change="districtChange"
              >
                <el-option
                  v-for="item in districtList"
                  :label="item.ItemName"
                  :key="item.ItemValue"
                  :value="item.ItemValue"
                >
                  {{ item.ItemName }}
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              :label="''"
              prop="ShippingTownShipID"
              :rules="[
                {
                  required: true,
                  message: $t('InvoiceInquiry.PleaseSelect'),
                  trigger: 'change'
                }
              ]"
            >
              <el-select
                v-model="ruleForm.ShippingTownShipID"
                :placeholder="$t('InvoiceInquiry.PleaseSelect')"
                clearable
                filterable
                remote
                :remote-method="searchDownTawn"
                @change="downTawnChange"
              >
                <el-option
                  v-for="item in downTawnList"
                  :label="item.ItemName"
                  :key="item.ItemValue"
                  :value="item.ItemValue"
                >
                  {{ item.ItemName }}
                </el-option>
              </el-select>
            </el-form-item>
          </el-form-item>
          <el-form-item
            :label="$t('HistoricalRedemptionRecords.DeliveryAddress')"
            prop="ShippingAddress"
            :rules="[
              {
                required: true,
                message: $t('InvoiceInquiry.PleaseEnter'),
                trigger: 'blur'
              }
            ]"
          >
            <el-input
              v-model="ruleForm.ShippingAddress"
              :placeholder="$t('InvoiceInquiry.PleaseEnter')"
            ></el-input>
          </el-form-item>
        </template>
        <el-form-item
          :label="$t('HistoricalRedemptionRecords.Note')"
          prop="Remark"
        >
          <el-input
            type="textarea"
            v-model="ruleForm.Remark"
            :placeholder="$t('InvoiceInquiry.PleaseEnter')"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{
        $t('ServiceEvaluation.Cancel')
      }}</el-button>
      <el-button type="primary" :loading="loading" @click="handleSubmit">{{
        $t('ServiceEvaluation.Confirm')
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { USER_INFO } from '@/store/mutation-types'
import i18n from '@/i18n/i18n'
import {
  submitOrder,
  getProvinces,
  getCity,
  getDistrict,
  getDownTawn,
} from '@/api/pointsMall'
export default {
  // props: ["integral", "title", "price", "storage", "imgUrl"],
  props: {
    goodsType: {
      type: Number,
      default: 0
    },
    selectedItem: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      ruleForm: {},
      rules: {
        ContactsName: [
          { required: true, message: i18n.t('InvoiceInquiry.PleaseEnter'), trigger: 'change' }
        ],
        ContactsPhone: [
          { required: true, message: i18n.t('InvoiceInquiry.PleaseEnter'), trigger: 'change' }
        ],
        // Num: [
        //   { required: true, message: '请填写兑换数量', trigger: 'change' }
        // ],
        ShippingTownShipID: [
          { required: true, message: i18n.t('InvoiceInquiry.PleaseEnter'), trigger: 'change' }
        ],
      },
      provincesList: [],
      cityList: [],
      districtList: [],
      downTawnList: [],
      // ShippingProvinceID,ShippingCityID,ShippingDistrictID,ShippingTownShipID
      ShippingProvinceName: undefined,
      ShippingCityName: undefined,
      ShippingDistrictName: undefined,
      ShippingTownShipName: undefined,
    }
  },
  computed: {
    userInfo() {
      return this.$ls.get(USER_INFO) || {}
    },
  },
  methods: {
    handleUsername(rule, value, callback) {
      const regex = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
      if (!regex.test(value)) {
        callback(new Error(i18n.t('PointsMall.filledInIsCorrect')))
      }
      callback()
    },
    conversion(goodsItem) {
      this.$emit('conversion', goodsItem, 1)
    },
    resetField() {
      this.ShippingProvinceName = undefined
      this.ShippingCityName = undefined
      this.ShippingDistrictName = undefined
      this.ShippingTownShipName = undefined
      if (this.goodsType == 0) {
        this.ruleForm = {
          ContactsName: undefined,
          ContactsPhone: undefined,
          ShippingProvinceID: undefined,
          ShippingCityID: undefined,
          ShippingDistrictID: undefined,
          ShippingTownShipID: undefined,
          ShippingAddress: undefined,
          Remark: undefined,
        }
      } else {
        this.ruleForm = {
          ContactsName: undefined,
          ContactsPhone: undefined,
          Remark: undefined,
        }
      }
    },
    handleClose() {
      if (this.dialogVisible) {
        this.$refs.ruleForm.resetFields()
      } else {
        this.searchProvince()
        this.resetField()
      }
      this.loading = false
      this.dialogVisible = !this.dialogVisible
    },
    handleSubmit() {
      if (this.loading) {
        return
      }
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          this.$confirm(i18n.t('PointsMall.filledInIsCorrect'), i18n.t('ChangePassword.Prompt'), {
            confirmButtonText: i18n.t('ServiceEvaluation.Confirm'),
            cancelButtonText: i18n.t('ServiceEvaluation.Cancel'),
            type: 'warning'
          }).then(() => {
            const params = {
              CustomerID: this.userInfo.CACode,
              CustomerName: this.userInfo.CAName,
              ProductID: this.selectedItem.ID,
              ProductName: this.selectedItem.CommodityName,
              ProductSpecifications: this.selectedItem.Specifications,
              CommodityLanguageType: this.$ls.get('lang') == 'zh' ? 0 : 1,
              ...this.ruleForm
            }
            if (this.goodsType == 0) {
              // params.UseIntegral = this.selectedItem.Integral
              params.Num = this.selectedItem.Num // 礼品类的商品要传兑换数量，服务类的不用传
              params.ShippingProvinceName = this.ShippingProvinceName
              params.ShippingCityName = this.ShippingCityName
              params.ShippingDistrictName = this.ShippingDistrictName
              params.ShippingTownShipName = this.ShippingTownShipName
            }
            submitOrder(params).then(res => {
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: i18n.t('PointsMall.SubmissionSuccessful')
                })
                this.handleClose()
                // this.getCustomerPointsInfo()
                this.$emit('submitSuccess')
              }
              this.loading = false
            }).catch(() => {
              this.loading = false
            })
          }).catch(() => {
            this.loading = false
            this.$message({
              type: 'info',
              message: i18n.t('HistoricalRedemptionRecords.Canceled')
            })
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      })
    },
    // 省下拉查询
    searchProvince(value) {
      getProvinces({ provinceName: value, CommodityLanguageType: this.$ls.get('lang') == 'zh' ? 0 : 1, }).then((res) => {
        this.provincesList = res.data || []
      })
    },
    provinceChange(val) {
      if (val) {
        const obj = this.provincesList.find(item => item.ItemValue === val)
        this.ShippingProvinceName = obj && obj.ItemName
        this.searchCity()
      } else {
        // provincesList: [],
        // cityList: [],
        // districtList: [],
        // downTawnList: [],
        // ShippingProvinceID,ShippingCityID,ShippingDistrictID,ShippingTownShipID
        this.ShippingProvinceName = undefined
        this.cityList = []
      }
      this.$nextTick(() => {
        this.ruleForm.ShippingCityID = undefined
        this.ruleForm.ShippingDistrictID = undefined
        this.ruleForm.ShippingTownShipID = undefined
        this.ShippingCityName = undefined
        this.ShippingDistrictName = undefined
        this.ShippingTownShipName = undefined
        this.districtList = []
        this.downTawnList = []
      })
    },
    // 所在城市下拉查询
    searchCity(value) {
      if (!this.ruleForm.ShippingProvinceID) {
        return
      }
      getCity({ provinceID: this.ruleForm.ShippingProvinceID, cityName: value, CommodityLanguageType: this.$ls.get('lang') == 'zh' ? 0 : 1, })
        .then((res) => {
          this.cityList = res.data || []
        })
    },
    cityChange(val) {
      if (val) {
        const obj = this.cityList.find(item => item.ItemValue === val)
        this.ShippingCityName = obj && obj.ItemName
        this.searchDistrict()
      } else {
        this.ShippingCityName = undefined
        this.districtList = []
      }
      this.$nextTick(() => {
        // this.ruleForm.ShippingCityID = undefined
        this.ruleForm.ShippingDistrictID = undefined
        this.ruleForm.ShippingTownShipID = undefined
        // this.ShippingCityName = undefined
        this.ShippingDistrictName = undefined
        this.ShippingTownShipName = undefined
        // this.districtList = []
        this.downTawnList = []
      })
    },
    // 所在区下拉查询
    searchDistrict(value) {
      if (!this.ruleForm.ShippingCityID) {
        return
      }
      getDistrict({ cityID: this.ruleForm.ShippingCityID, districtName: value, CommodityLanguageType: this.$ls.get('lang') == 'zh' ? 0 : 1, })
        .then((res) => {
          this.districtList = res.data || []
        })
    },
    districtChange(val) {
      if (val) {
        const obj = this.districtList.find(item => item.ItemValue === val)
        this.ShippingDistrictName = obj && obj.ItemName
        this.searchDownTawn()
      } else {
        this.ShippingDistrictName = undefined
        this.downTawnList = []
      }
      this.$nextTick(() => {
        this.ruleForm.ShippingTownShipID = undefined
        this.ShippingTownShipName = undefined
      })
    },
    // 所在街道下拉查询
    searchDownTawn(value) {
      if (!this.ruleForm.ShippingDistrictID) {
        return
      }
      getDownTawn({ districtID: this.ruleForm.ShippingDistrictID, townShipName: value, CommodityLanguageType: this.$ls.get('lang') == 'zh' ? 0 : 1, })
        .then((res) => {
          this.downTawnList = res.data || []
        })
    },
    downTawnChange(val) {
      console.log(val)
      if (val) {
        const obj = this.downTawnList.find(item => item.ItemValue === val)
        this.ShippingTownShipName = obj && obj.ItemName
      } else {
        this.ShippingTownShipName = undefined
      }
      console.log(this.ruleForm.ShippingTownShipID)
    },
  }
}
</script>

<style lang="less" scoped>
.exchange-form-dialog {
  /deep/ .el-input__inner,
  /deep/ .el-textarea__inner {
    border: 1px solid #dcdfe6 !important;
    background: #ffffff !important;
  }
  .el-form-item__error {
    position: relative;
  }
  .el-form-item.address-select {
    /deep/.el-form-item__label {
      &::before {
        content: '*';
        color: #f56c6c;
        margin-right: 4px;
      }
    }
    /deep/.el-form-item__content {
      display: flex;
    }
    .el-form-item {
      margin-top: 0;
    }
  }
}
</style>
